module.exports = __webpack_public_path__ + "static/img/吕梦涵.7ff72b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/吕梦涵.jpg
// module id = WctS
// module chunks = 1